import { combineReducers } from 'redux';
import { authTokenReducer, twoFactorRequiredReducer } from './auth/reducer.js';
import { SITE } from './config.js';
import * as creditors from './creditors/reducer.js';
import selectedExclusiveContentReducer from './exclusiveContent/reducer.js';
import { currentLangReducer, langReducer } from './lang/reducer.js';
import { leftNavOpenReducer, rightNavOpenReducer } from './local/reducer.js';
import redirectReducer from './redirect/reducer.js';
import { activeUsersReducer } from './users/activeUsersReducer.js';
console.log(SITE);
const appReducer = combineReducers({
    activeUsers: activeUsersReducer,
    authToken: authTokenReducer,
    currentLang: currentLangReducer,
    lang: langReducer,
    leftNavOpen: leftNavOpenReducer,
    redirectTo: redirectReducer,
    rightNavOpen: rightNavOpenReducer,
    selectedCreditor: creditors.selectedCreditorReducer,
    selectedExclusiveContent: selectedExclusiveContentReducer,
    site: () => SITE,
    twoFactorRequired: twoFactorRequiredReducer,
});
const rootReducer = (state, action) => {
    if (action.type === 'LOGOUT') {
        return appReducer(undefined, action);
    }
    return appReducer(state, action);
};
export default rootReducer;
//# sourceMappingURL=reducer.js.map